import React from 'react';
import PropTypes from 'prop-types';
import ComboBox from '../Form/ComboBox';
import QuoteFeedActions from '../../Actions/QuoteFeedActions';
import QuoteFeedSymbolsActions from '../../Actions/QuoteFeedSymbolsActions';

import QuoteFeedStore from '../../Stores/QuoteFeedStore';
import QuoteFeedSymbolsStore from '../../Stores/QuoteFeedSymbolsStore';

class FeedSymbol extends React.Component {
  static defaultProps = {
    disabled: false,
    name: '',
    value: 0
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      feedId: this.props.value === Constants.Diff ? Constants.Diff : 0,
      haveDiff: this.props.value === Constants.Diff
    };
    this.onChangeStore = this.onChangeStore.bind(this);
    this.onChangeFeed = this.onChangeFeed.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    QuoteFeedStore.addChangeListener(this.onChangeStore);
    QuoteFeedSymbolsStore.addChangeListener(this.onChangeStore);
    QuoteFeedActions.update();
    QuoteFeedSymbolsActions.update();
  }

  componentWillUnmount() {
    QuoteFeedStore.removeChangeListener(this.onChangeStore);
    QuoteFeedSymbolsStore.removeChangeListener(this.onChangeStore);
  }

  onChangeStore() {
    let feedSymbol = QuoteFeedSymbolsStore.get(this.props.value);
    let feedId = this.state.feedId;
    if (feedSymbol) {
      feedId = feedSymbol.FeedId;
    }

    this.setState({feedId: feedId});
  }

  onChangeFeed(name, value) {
    let intValue = value === Constants.Diff ? value : parseInt(value, 10);
    this.setState({feedId: intValue});
  }

  onChange(name, value) {
    let intValue = value === Constants.Diff ? value : parseInt(value, 10);

    this.props.onChange && this.props.onChange(this.props.name, intValue);
  }

  getFeedOptions() {
    let options = QuoteFeedStore.getForSelect();

    if (this.state.haveDiff) {
      options.push({value: Constants.Diff, label: Constants.Diff});
    }

    return options;
  }

  getSymbolOptions() {
    let symbols = QuoteFeedSymbolsStore.getSymbols(this.state.feedId);
    let options = symbols.map(sym => ({value: sym.Id, label: sym.Name + "(" + sym.Id + ")"}));

    if (this.state.haveDiff) {
      options.push({value: Constants.Diff, label: Constants.Diff});
    }

    return options;
  }

  getParentSymbolId(id) {
    if (id === Constants.Diff) {
      return id;
    }

    let sym = QuoteFeedSymbolsStore.get(id);
    if (sym && sym.ParentId !== 0) {
      return this.getParentSymbolId(sym.ParentId);
    }

    return id;
  }

  render() {
    return (<div>
      <ComboBox name="feedId"
                grid={1 / 2}
                sorted={true}
                value={this.state.feedId}
                options={this.getFeedOptions()}
                onChange={this.onChangeFeed}
                disabled={this.props.disabled}
      />
      <ComboBox name={this.props.name}
                grid={1 / 2}
                sorted={true}
                value={this.getParentSymbolId(this.props.value)}
                options={this.getSymbolOptions()}
                onChange={this.onChange}
                disabled={this.props.disabled}
      />
    </div>);
  }
}

export default FeedSymbol;



// WEBPACK FOOTER //
// ./src/js/Component/Form/FeedSymbol.jsx